(ns frontend.ui.page.lp-report-editor.step-5-approved.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.ui.page.lp-report-editor.event :as editor-event]))


(rf/reg-event-fx
 ::reset
 (fn [{db :db} _]
   {:db (assoc-in db [:lp-report-editor :approve] nil)}))

(rf/reg-event-fx
 ::to-publishing-queue-ok
 (fn [{db :db} [_ investor-identifier resp]]
   {:db (-> db
            (assoc-in [:lp-report-editor :lp-report :lp-report/step]
                      :lp-report.step/publishing-queue))
    :fx [[:dispatch [::editor-event/activate-step :lp-report.step/publishing-queue]]]}))

(rf/reg-event-fx
 ::to-publishing-queue-failed
 (fn [{db :db} [_ err]]
   (js/console.log "To publishing queue failed : " err)))

(rf/reg-event-fx
 ::to-publishing-queue
 (fn [{db :db} [_ report-id]]
   {::ws/send {:id         :lp-report/send-to-publish-queue
               :body       {:report-id report-id}
               :on-success [::to-publishing-queue-ok report-id]
               :on-error   [::to-publishing-queue-failed report-id]}}))
